import { getDate, getDateTime } from '../../../../utils/functions';
import Loading from '../../../../components/Loading';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineOppositeContent, {
    timelineOppositeContentClasses
} from '@mui/lab/TimelineOppositeContent';

const getAction = (action: string) => {
    switch (action) {
        case 'carga':
            return 'cargó';
        case 'confirmar':
            return 'confirmó';
        case 'eliminar':
            return 'eliminó';
        default:
            return 'descargó';
    }
};
export default function TimelineComponent({ items, loading }: any) {
    return (
        <Timeline
            position="right"
            sx={{
                [`& .${timelineOppositeContentClasses.root}`]: {
                    flex: 0.2
                },
                '& .MuiTimelineItem-root': {
                    minHeight: '82px'
                },
                '& .MuiTimelineContent-root .MuiTimelineOppositeContent-root': {
                    overflowWrap: 'anywhere',
                    display: 'flex',
                    alignItems: 'center'
                },
                '& .MuiTimelineSeparator-root': {
                    '& .MuiTimelineDot-root': {
                        margin: '21.5px 0 14px 0 !important',
                        backgroundColor: 'var(--primary)'
                    },
                    '& .MuiTimelineConnector-root': {
                        width: '2px',
                        backgroundColor: 'var(--primary)'
                    }
                }
            }}
        >
            {loading ? (
                <Loading />
            ) : !!items?.data?.length ? (
                items?.data?.map((item: any, index: number) => (
                    <TimelineItem key={index}>
                        <TimelineOppositeContent color="text.secondary">
                            <div>
                                <span>{getDate(item?.fecha)}</span>
                                <br />
                                <span>{getDateTime(item?.fecha)?.substring(10)}</span>
                            </div>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <TimelineDot />
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                            <div>
                                <b>El operador {item?.cuilOperador}</b>
                                <br />
                                <label>{getAction(item?.accion)} el documento</label>
                            </div>
                        </TimelineContent>
                    </TimelineItem>
                ))
            ) : (
                <div className="flex-center">
                    <h4>Sin registros</h4>
                </div>
            )}
        </Timeline>
    );
}
